import { render, staticRenderFns } from "./DIMDDetail.vue?vue&type=template&id=2075a6be&scoped=true"
import script from "./DIMDDetail.vue?vue&type=script&lang=js"
export * from "./DIMDDetail.vue?vue&type=script&lang=js"
import style0 from "./DIMDDetail.vue?vue&type=style&index=0&id=2075a6be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2075a6be",
  null
  
)

export default component.exports